module.exports = __webpack_public_path__ + "img/hongxiuquan.ae649756.png";